import APIRequest from "./APIRequest";
import { getLocation } from "./locationService";

export const getAlerts = async ({ page = 1, search = "", location = null,isAdminLoggedIn }) => {
  let params = {
    stopLoading: true,
  };
  
  // If no location provided, get current location
  // if (!location) {
  //   try {
  //     const currentLocation = await getLocation();
  //     location = `${currentLocation.city},${currentLocation.country}`;
  //   } catch (error) {
  //     console.error('Error getting location for alerts:', error);
  //     location = "Karachi,Pakistan"; // Fallback
  //   }
  // }
  
  let url =isAdminLoggedIn?`admin/alerts?location=${location}`: `user/alerts?location=${location}`;
  if (search) {
    url += `&search=${search}`;
  }
  return APIRequest.get(url, params);
};

export const createAlert = (alertData) => {
  return APIRequest.post(`user/alerts/create`, alertData);
};

export const updateAlert = ({ id, ...alertData }) => {
  return APIRequest.put(`user/alerts/${id}`, alertData);
};

export const deleteAlert = ({ id }) => {
  return APIRequest.delete(`user/alerts/${id}`);
};

export const toggleAlert = ({ id, is_active }) => {
  return APIRequest.patch(`user/alerts/${id}/toggle`, { is_active });
};
